export function reorderById<T extends { id: string }>(
  items: T[],
  dragId: string,
  dropId: string,
): T[] {
  if (dragId === dropId) return items;

  const next = [...items];
  const dragIndex = next.findIndex((item) => item.id === dragId);
  const dropIndex = next.findIndex((item) => item.id === dropId);

  if (dragIndex < 0 || dropIndex < 0) return items;

  const [moved] = next.splice(dragIndex, 1);
  next.splice(dropIndex, 0, moved);
  return next;
}
